import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/home.vue'
import Activate from './pages/activate/index.vue'
import Register from './pages/register/index.vue'
import Reseller from './pages/reseller/index.vue'
import ResellerActivate from './pages/activate/reseller.vue'
import BuildYourDeal from './pages/build-your-deal/index.vue'
import MobileFaqs from './pages/build-your-deal/faqs.vue'
import FixedLte from './pages/fixed-lte/index.vue'
import FixedLteFaqs from './pages/fixed-lte/faqs.vue'
import FixedLteRecharge from './pages/fixed-lte/recharge'
import HotDeals from './pages/build-your-deal/hot-deals.vue'
import Checkout from './pages/checkout/index.vue'
import Payment from './pages/payment.vue'
import PaymentProcessed from './pages/payment-processed.vue'
import PaymentSuccessful from './pages/payment-successful.vue'
import PaymentFailed from './pages/payment-failed.vue'
import Pricing from './pages/pricing.vue'
import Recharge from './pages/recharge/index.vue'
import ContactUs from './pages/contact-us.vue'
import Terms from './pages/compliance/terms.vue'
import PrivacyPolicy from './pages/compliance/privacy-policy.vue'
import FupPolicy from './pages/compliance/fup-policy.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: "me&you mobile | SA's 1st SIM-Only Mobile Network",
      }
    },
    {
      path: '/activate',
      name: 'activate',
      component: Activate
    },
    {
      path: '/complete-activation',
      name: 'complete-activation',
      component: ResellerActivate
    },
    {
      path: '/build-your-deal',
      name: 'build-your-deal',
      component: BuildYourDeal, props: { iccid: '', builder: true }
    },
    {
      path: '/mobile/build-your-deal',
      name: 'mobile-build-your-deal',
      component: BuildYourDeal, props: { iccid: '', builder: true }
    },
    {
      path: '/mobile/faqs',
      name: 'mobile-faqs',
      component: MobileFaqs, props: { iccid: '', builder: true }
    },
    {
      path: '/fixed-lte/signup',
      name: 'fixed-lte-signup',
      component: FixedLte, props: { iccid: '', builder: false, place: false }
    },
    {
      path: '/fixed-lte/signup/:deal',
      name: 'fixed-lte-deal',
      component: FixedLte, props: { builder: false, place: false }
    },
    {
      path: '/fixed-lte/faqs',
      name: 'fixed-lte-faqs',
      component: FixedLteFaqs
    },
    {
      path: '/fixed-lte/recharge',
      name: 'fixed-lte-recharge',
      component: FixedLteRecharge
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout
    },
    {
      path: '/reseller',
      name: 'reseller',
      component: Reseller
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/hot-deals',
      name: 'hot-deals',
      component: HotDeals, props: { builder: false }
    },
    {
      path: '/hot-deals/:deal',
      name: 'hot-deals-deal',
      component: HotDeals, props: { builder: false }
    },
    {
      path: '/mobile/hot-deals',
      name: 'mobile-hot-deals',
      component: HotDeals, props: { builder: false }
    },
    {
      path: '/mobile/hot-deals/:deal',
      name: 'mobile-hot-deals-deal',
      component: HotDeals, props: { builder: false }
    },
    {
      path: '/call-centre',
      name: 'call-centre',
      component: () => import('./pages/call-centre/index.vue'),
      props: { builder: false }
    },
    {
      path: '/call-centre-complete',
      name: 'call-centre-complete',
      component: () => import('./pages/call-centre/complete.vue'), 
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: Pricing
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: Recharge
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs
    },
    {
      path: '/compliance/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/compliance/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '/compliance/fup-policy',
      name: 'fup-policy',
      component: FupPolicy
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment, 
      props: { CHECKSUM: false, PAY_REQUEST_ID: false }
    },
    {
      path: '/manage/payment',
      name: 'payment-manage',
      component: Payment, 
      props: (route) => ({ 
        CHECKSUM: route.query.CHECKSUM,
        PAY_REQUEST_ID: route.query.PAY_REQUEST_ID,
        payment_type: "credit_card_manage"
      })      
    },
    {
      path: '/payment-processed',
      name: 'payment-processed',
      component: PaymentProcessed
    },
    {
      path: '/payment/successful',
      name: 'payment-successful',
      component: PaymentSuccessful
    },
    {
      path: '/payment/failed',
      name: 'payment-failed',
      component: PaymentFailed
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // eslint-disable-next-line
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router